/*
  biit (B-083): a click on the energy arrow shows the official EU label in a window on the page,
  instead of sending the customer to EPREL. The arrow is a link to the label, so it still works
  without JavaScript, and Cmd/Ctrl-click opens it in a new tab as usual.
*/
(() => {
  if (typeof HTMLDialogElement !== 'function') return;
  let dialog;
  let opener;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'biit-energy-dialog';
    dialog.innerHTML = '<button type="button" class="biit-energy-dialog__close" aria-label="Lukk">&times;</button><img alt="">';
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('.biit-energy-dialog__close')) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (opener) opener.focus();
    });
    document.body.appendChild(dialog);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.biit-energy__arrow');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    event.stopPropagation(); // product cards are links themselves
    if (!dialog) build();
    const img = dialog.querySelector('img');
    img.src = link.href;
    img.alt = link.dataset.alt || 'Energimerke';
    opener = link;
    dialog.showModal();
  }, true);
})();
